<template>
    <div class="ModalLogin" >
        <b-modal ref="modal-login" id="modalLogin" size="md" :hide-footer="true" :hide-header="true">
            <div class="row justify-content-arround txt-size-20 txt-blue-2">
                <div class="col-8">
                    <img class="logo-capacitacao" :src="logo" />
                    
                </div>
                <div class="col-4 text-end">
                    <span class="" @click="close"><i class="fas fa-times c-pointer"></i></span>
                </div>
                
            </div>
            <form class="px-3 pb-3" id="formLoginModal">
                <p class="txt-p txt-size-20 txt-blue-2 txt-w-7 mb-3 mt-3"> Entre em sua conta </p>
                <div class="form-group mb-2">
                    <label class="label-form txt-p txt-blue-2 txt-w-5 txt-size-16" for="usuarioCRUD_dsLogin">Email</label>
                    <input class="w-100 input-text" type="text" placeholder="Usuário" v-model="userLogin.login" required />
                    <span class="label-validacao field-validation-valid" data-valmsg-for="usuarioCRUD.dsLogin" data-valmsg-replace="true"></span>
                </div>
                <div class="form-group">
                    <label class="label-form txt-p txt-blue-2 txt-w-5 txt-size-16" for="usuarioCRUD_dsSenha">Senha</label>
                    <input class="w-100 input-text" type="password" name="senha" value="" placeholder="Senha" v-model="userLogin.password" v-on:keyup.enter="entrar" required />
                    <span class="label-validacao field-validation-valid" data-valmsg-for="usuarioCRUD.dsSenha" data-valmsg-replace="true"></span>
                </div>

                <div class="row">
                    
                </div>
                <div class="row footer-login">
                    <div class="col-12 col-sm-4 mb-4 mb-sm-0">
                        <a class="txt-p txt-size-12 esqueceu-senha c-pointer"  onclick="modalEsqueciSenha()"> Esqueceu sua senha ?</a>
                    </div>
                    <div class="col-12 col-sm-8 text-end">
                        <button type="button" class="btn btn-blue p-0 px-3 me-3 txt-size-16" onclick="modalCadastroUsuario()">Cadastre-se</button>
                        <button class="btn btn-yellow p-0 px-3 txt-size-16" type="button" @click="entrar">
                            Entrar
                        </button>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import logo from '@/assets/img/logo-azul.png';
    import { urlApi, avisoSucesso, avisoErro, idModulo } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'ModalLogin',
        data: function () {
            return {
                logo,

                userLogin: {
                    login: "",
                    password: "",
                    idModulo: idModulo,
                },
            }
        },
        props: {
            showModal: Boolean,
        },
        computed: {
            
        },        
        methods: {
            entrar(event) {
                event.preventDefault();
                if (this.checkForm()) {
                    let $this = this;
                    axios.post(`${urlApi}/Auth/signin`, this.userLogin)
                        .then(res => {
                            if (res.data.token.authenticated) {
                                res.data.token.usuario = res.data.usuario;
                                $this.$store.commit('setUser', res.data.token);
                                avisoSucesso('Login realizado com sucesso.');
                                $this.close();
                            } else {
                                avisoErro("Erro ao realizar login.");
                            }
                        })
                        .catch(function () {
                            avisoErro("Login e/ou senha inválidos.");
                        })
                }

                return false;
            },

            checkForm() {
                var form = document.getElementById('formLoginModal')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                return true;
            },


            close() {
                this.$refs['modal-login'].hide();
            },

        },
        created: function () {
        },
        watch: {
            showModal: function () {
                this.$refs['modal-login'].show();
            },
            
        }
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* Modal Login */
   .form-control {
        border: 1px solid #474747;
    }

    .logo-capacitacao{
        width: 200px;
    }

    .esqueceu-senha {
        font-size: 0.8rem;
        font-weight: 500;
        color: #173244;
    }

    .footer-login {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0 0 0;
    }
        
</style>

